const getDefaultState = () => {
  return {
    deliveryOptions: {
      item: {
        document: { on: false, number: 0 },
        smallBox: { on: false, number: 0 },
        bigBox: { on: false, number: 0 },
        etc: { on: false, content: null }
      },
      weight: 3,
      vehicleCategory: null, //운송수단
      vehicleType: null, //차종
      vehicleItemCode: 1, //차종에 따른 아이템 코드 (1:일반,2:화물)
      vehicleOption: null, //차량특성
      loadingPosition: null, //상차위치
      unloadingPosition: null, //하차위치
      loadingMethod: null, //상차방법
      unloadingMethod: null, //하차방법

      timeChargeFee: 0, // 시간할증 요금
      weatherChargeFee: 0, // 기상할증 요금
      specialDayChargeFee: 0, // 특수일 할증
      baseFee: 0, //기본요금
      weightFee: 0, // 무게요금
      distanceFee: 0, // 거리요금
      freightDistanceFee: 0, //화물 거리별 요금
      waypointsFee: 0, // 경유지 요금
      notifiedPrice: 0, //총요금(부가세 불포함) 현재 사용 안함.
      vat: 0, //부가세
      totalExtraFee: 0, //총 할증 요금
      deliveryfixedFee: 0, //배송요금 백단위절사
      additionalfixedFee: 0, //할증요금 백단위절사
      totalOrderFee: 0, //최종요금
      totalDeliveryFee: 0, //총 배송요금
      fixedFee: 0, //할증운임 백단위 절사
      expressDeliveryFee: 0, //급송요금
      extraFixedFee: 0, // 할증운임 백단위절사
      displayNormalTotalFee: 0, //노출용 일반 최종요금
      displayExpressTotalFee: 0, //노출용 급송 최종 요금
      totalFee: 0,
      freightOptionsFee: 0, //화물 총 옵션 요금
      clientComment: "", //고객 요청사항
      calcUuid: "",
      totalDistance: 0,
      applicant: {
        name: "",
        phoneNumber: ""
      },
      clitentMemo: "", //고객(신청인) 개인 메모
      isReserved: null,
      isExpressDelivery: null,

      estimatedMinutes: null,
      expressEstimatedMinutes: null,
      reserveEstimatedMinutes: null,
      reserveExpressEstimatedMinutes: null
    },
    pins: [
      {
        name: "",
        phoneNumber: "",
        dongName: "",
        coords: null,
        jibunAddress: "",
        roadAddress: "",
        detailAddress: "",
        addToBookmark: false,
        pickupDate: "",
        pickupHour: "",
        pickupMinute: "",
        pinMemo: ""
      },
      {
        name: "",
        phoneNumber: "",
        dongName: "",
        coords: null,
        jibunAddress: "",
        roadAddress: "",
        pickupDate: "",
        pickupHour: "",
        pickupMinute: "",
        detailAddress: "",
        addToBookmark: false,
        pinMemo: ""
      }
    ]
  };
};
export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    updateDeliveryOptions(state, payload) {
      state.deliveryOptions = _.cloneDeep(payload);
    },
    updateDisplayFess(state, payload) {
      state.deliveryOptions.displayExpressTotalFee = payload.express;
      state.deliveryOptions.displayNormalTotalFee = payload.normal;
    },
    updatePins(state, payload) {
      state.pins = _.cloneDeep(payload);
    },
    updateIsReserved(state, payload) {
      state.deliveryOptions.isReserved = payload;
    },
    updateIsExpressDelivery(state, payload) {
      state.deliveryOptions.isExpressDelivery = payload;
    },
    updatePickupTime(state, payload) {
      state.pins[0].pickupDate = payload.date;
      state.pins[0].pickupHour = payload.hour;
      state.pins[0].pickupMinute = payload.minute;
    },
    updateVehicleCategory(state, payload) {
      state.deliveryOptions.vehicleCategory = payload;
    },
    updateVehicleType(state, payload) {
      state.deliveryOptions.vehicleType = payload;
    },
    updateVehicleItemCode(state, payload) {
      state.deliveryOptions.vehicleItemCode = payload;
    },
    updateVehicleOptions(state, payload) {
      state.deliveryOptions.vehicleOption = payload;
    },
    updateLoadingPosition(state, payload) {
      state.deliveryOptions.loadingPosition = payload;
    },
    updateUnLoadingPosition(state, payload) {
      state.deliveryOptions.unloadingPosition = payload;
    },

    updateLoadingMethod(state, payload) {
      state.deliveryOptions.loadingMethod = payload;
    },
    updateUnLoadingMethod(state, payload) {
      state.deliveryOptions.unloadingMethod = payload;
    },
    updatePinMemo(state, payload) {
      state.pins[payload.idx].pinMemo = payload.memo;
    },

    updateClientComment(state, payload) {
      state.deliveryOptions.clientComment = payload;
    },
    updateApplicantName(state, payload) {
      state.deliveryOptions.applicant.name = payload;
    },
    updateApplicantPhoneNumber(state, payload) {
      state.deliveryOptions.applicant.phoneNumber = payload;
    },

    updateClientMemo(state, payload) {
      state.deliveryOptions.clientMemo = payload;
    },

    updatePinFromModal(state, payload) {
      //자주쓰는 주소 선택
      state.pins[payload.idx].name = payload.name;
      state.pins[payload.idx].phoneNumber = payload.phoneNumber;
      state.pins[payload.idx].jibunAddress = payload.jibunAddress;
      state.pins[payload.idx].detailAddress = payload.detailAddress;
      state.pins[payload.idx].dongName = payload.dongName;
      state.pins[payload.idx].roadAddress = payload.roadAddress;
      state.pins[payload.idx].coords = payload.coords;

      if (payload.addressElements) {
        state.pins[payload.idx].addressElements = payload.addressElements;
      }
    },

    updatePinName(state, payload) {
      state.pins[payload.idx].name = payload.name;
    },
    updatePhoneNumber(state, payload) {
      state.pins[payload.idx].phoneNumber = payload.phoneNumber;
    },

    updateEstimatedMinutes(state, payload) {
      state.deliveryOptions.estimatedMinutes = payload.estimatedMinutes;
      state.deliveryOptions.expressEstimatedMinutes =
        payload.expressEstimatedMinutes;
      state.deliveryOptions.reserveEstimatedMinutes =
        payload.reserveEstimatedMinutes;
      state.deliveryOptions.reserveExpressEstimatedMinutes =
        payload.reserveExpressEstimatedMinutes;
    },

    updateDeliveryOptionsAfterCalc(state, payload) {
      state.deliveryOptions.calcUuid = payload.calcUuid;
      state.deliveryOptions.totalDistance = payload.totalDistance;
      state.deliveryOptions.estimatedMinutes = payload.estimatedMinutes;
      state.deliveryOptions.expressEstimatedMinutes =
        payload.expressEstimatedMinutes;
      state.deliveryOptions.reserveEstimatedMinutes =
        payload.reserveEstimatedMinutes;
      state.deliveryOptions.reserveExpressEstimatedMinutes =
        payload.reserveExpressEstimatedMinutes;
    },
    updateFeeAfterCalc(state, payload) {
      state.deliveryOptions = payload;
    },

    updateWeight(state, payload) {
      state.deliveryOptions.weight = payload;
    },

    updateItem(state, payload) {
      state.deliveryOptions.item[payload.key].number = payload.number;
      state.deliveryOptions.item[payload.key].on = payload.on;
    },
    updateItemEtc(state, payload) {
      state.deliveryOptions.item["etc"].on = payload.on;
      state.deliveryOptions.item["etc"].content = payload.content;
    },

    updateAddToBookmark(state, payload) {
      state.pins[payload.idx].addToBookmark = payload.value;
    }
  },
  getters: {
    getDeliveryOptions: (state, getters, rootState, rootGetters) => () => {
      return state.deliveryOptions;
    },
    getPins: (state, getters, rootState, rootGetters) => () => {
      return state.pins;
    },
    getOrder: (state, getters, rootState, rootGetters) => () => {
      return state;
    }
  },
  actions: {}
};
